var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BasicLayout',{scopedSlots:_vm._u([{key:"wrapper",fn:function(){return [_c('el-card',{staticClass:"box-card"},[_c('div',{ref:"chartContainer",staticStyle:{"width":"100%","height":"400px"}})])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }